import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Banner from "../components/Banner/Banner";
import Header from "../../layouts/Header/Header";
import ProductDetail from "../components/ProductDetail/ProductDetail";
import Footer from "../../layouts/Footer/Footer";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Project = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const animationVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const AnimatedSection = ({ children }) => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
      <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={animationVariants}
        transition={{ duration: 0.8 }}
      >
        {children}
      </motion.div>
    );
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `https://estate.deltaservis.com.tr/items/${id}/${id}.json`
        );
        setProduct(response.data);
      } catch (err) {
        console.error("Veri çekme sırasında hata oluştu:", err);
        setProduct({
          name: "Ürün Bulunamadı",
          description: "Hatalı ürün ID'si.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return "";
  }

  return (
    <div>
      <Header />
      <Banner effect={"parallax"} />
      <AnimatedSection>
        <ProductDetail product={product} />
      </AnimatedSection>
      <Footer />
    </div>
  );
};

export default Project;
